<script>
  import { Line } from 'vue-chartjs'
  import { merge } from 'lodash'

  const defaultOptions = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 1,
        bottom: 1
      }
    },
    hover: {
      intersect: false,
      mode: 'label'
    },
    tooltips: {
      intersect: false,
      mode: 'label',
      displayColors: false
    },
    legend: {
      display: false
    },
    elements: {
      line: {
        borderWidth: 2,
        cubicInterpolationMode: 'monotone'
      },
      point: {
        radius: 0,
        hoverRadius: 4,
        pointStyle: 'round'
      }
    },
    scales: {
      yAxes: [
        {
          display: false,
          ticks: {
            suggestedMin: 0
          }
        }
      ],
      xAxes: [
        {
          display: false
        }
      ]
    }
  }

  export default {
    name: 'Sparkline',
    extends: Line,
    props: {
      chartdata: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    watch: {
      chartdata () {
        this.renderChart(this.chartdata, merge({}, this.options, defaultOptions))
      }
    },
    mounted () {
      this.renderChart(this.chartdata, merge({}, this.options, defaultOptions))
    }
  }
</script>
